import React from 'react'

import { Skeleton } from '../../../../../ui/skeleton'

export const SimpleEmpty = () => {
  return (
    <div className="flex flex-col gap-5">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="rounded-xl border border-black/10 bg-white py-4 px-6">
          <div className="flex flex-wrap items-center gap-3">
            <Skeleton className="h-[43px] w-[43px] rounded-lg" />
            <div className="flex-1">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="mt-1 h-3 w-44" />
            </div>
            <div className="ml-auto flex items-center gap-2">
              <Skeleton className="h-4 w-44 rounded-full" />
              <Skeleton className="h-6 w-6 rounded-full" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
